import { render } from "./EmployeeViewRequest.vue?vue&type=template&id=2e9fe90a"
import script from "./EmployeeViewRequest.vue?vue&type=script&lang=js"
export * from "./EmployeeViewRequest.vue?vue&type=script&lang=js"

import "./EmployeeViewRequest.vue?vue&type=style&index=0&id=2e9fe90a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__